import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { bottom } from "@popperjs/core";
import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import { extractDate, uploadImage } from "../../utils/functions";
import { subAdminValidator } from "../../utils/validators";

import dummyProfile from "../../assets/images/lady.png";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ErrorMessage } from "formik";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  Paper,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import "./subAdmin.css"
import { ToastContainer } from 'react-toastify';
import * as Yup from "yup";
// icons
import { SlClose } from "react-icons/sl";
import { FaArrowLeft } from "react-icons/fa";
import { IoIosLogOut } from "react-icons/io";
import { TiInfoOutline } from "react-icons/ti";
import { BiSolidPackage } from "react-icons/bi";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { GrApple, GrAndroid } from "react-icons/gr";
import { PiHandsClappingBold, PiUserList } from "react-icons/pi";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import {
  MdBlock,
  MdClose,
  MdEmail,
  MdLocalPhone,
  MdPhone,
} from "react-icons/md";
import {
  FaFilter,
  FaGlobe,
  FaPhone,
  FaUser,
  FaUserAlt,
  FaMoneyBill,
} from "react-icons/fa";
import {
  IoArchive,
  IoArrowBackCircleOutline,
  IoArrowForwardCircleOutline,
} from "react-icons/io5";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  DashHeading,
  Button,
  Fields,
  Resetbtn,
  Applybtn,
  ProfileDetailForm,
  SubAdminAddUpatecant,
} from "./SubAdminElements";

const useStyles = makeStyles((theme) => ({
  // table: {
  //   borderCollapse: 'separate',
  //   borderSpacing: '0 6px', // adds vertical spacing between rows
  // },
  tableMainContainer: {
    maxHeight: "65vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    // border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",
    // border: "1px solid rgba(17, 153, 38, 0.20)",

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "16px",
    color: "#000000",
    fontFamily: "Roboto",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none"
  },
  textMiddle: {
    // padding: "0.4rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none"
  },
}));

const AddUpdateSubAdmin = ({ setUsers, userData }) => {
  const classes = useStyles();
  const location = useLocation();
  const adminStateData = location.state?.admin;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const defaultModules = [
    "Dashboard",
    "User Management",
    "Skill Management",
    "Blacklist Word Management",
    "Commission Management",
    "Gigs Management",
    "Reported Gig Management",
    "CMS Management",
    "Payment Management",
    "Notification Management",
    "Leader board",
    "Ticket Management",
    "Feedback Management"

  ];

  const disabledPermissions = {
    "Dashboard": ["add", "edit", "delete", "blockUnblock"],
    "User Management": ["add", "edit"],
    "Skill Management": ["add", "edit", "download"],
    "Blacklist Word Management": ["blockUnblock"],
    "Commission Management": ["add", "delete", "blockUnblock", "download"],
    "Gigs Management": ["add", "edit", "delete"],
    "Reported Gig Management": ["add", "delete", "edit", "download"],
    "CMS Management": ["blockUnblock", "download"],
    "Payment Management": ["add", "edit","delete", "blockUnblock"],
    "Notification Management": ["edit", "delete", "blockUnblock", "download"],
    "Leader board": ["add", "edit", "delete", "blockUnblock"],
    "Ticket Management": ["add", "edit", "delete", "blockUnblock","download"],
    "Feedback Management": ["add", "edit", "delete", "blockUnblock"],
  };

  const getInitialModules = () => {
    return defaultModules.map((moduleName) => ({
      moduleName,
      permissions:
        adminStateData?.modules?.find((mod) => mod.moduleName === moduleName)?.permissions || {
          view: false,
          add: false,
          edit: false,
          delete: false,
          blockUnblock: false,
          download: false,
        },
    }));
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);

    const payload = {
      subAdminName: values.firstName,
      subAdminTitle: values.subAdminTitle,
      countryCode: values.countryCode,
      phoneNumber: values.phoneNumber,
      email: values.email,
      modules: values.modules,
    };

    try {
      if (values.id) {
        console.log("object", values)
        // Update sub-admin
        const { data } = await axios.post(`/private/updateSubadmin/${values.id}`, payload);
        toast.success(data?.message, { position: "top-right" });
      } else {
        // Add sub-admin
        const { data } = await axios.post(`/private/createSubadmin`, payload);
        toast.success(data?.message, { position: "top-right" });
      }

      navigate("/subAdminManagement");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.[0]?.msg ||
        error?.response?.data?.message;

      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");
        navigate("/");
      }

      toast.error(errorMessage, { position: "top-right" });
    } finally {
      setIsLoading(false);


    }
  };


  const permissionOrder = ["view", "add", "edit", "delete", "blockUnblock", "download"];



  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm>
            <div
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center"
              onClick={() => {
                navigate("/subAdminManagement");
              }}
            >
              <HiArrowNarrowLeft style={{ fontSize: "1.5rem" }} />
              {adminStateData?._id ? (
                <div className="common-heading ps-2">Edit Sub Admin</div>
              ) : (
                <div className="common-heading ps-2">Add Sub Admin</div>
              )}
            </div>

            <Formik
              enableReinitialize
              initialValues={{
                id: adminStateData?.subadmins?._id || "",
                firstName: adminStateData?.subadmins?.firstName || "",
                subAdminTitle: adminStateData?.subAdminTitle || "",
                countryCode: adminStateData?.subadmins?.countryCode || "",
                phoneNumber: adminStateData?.subadmins?.phoneNumber || "",
                email: adminStateData?.subadmins?.email || "",
                modules: getInitialModules(),
              }}
              validate={subAdminValidator}
              validateOnChange
              onSubmit={handleSubmit}
            >
              {({ values, setFieldValue, handleBlur, touched, errors }) => (
                <Form style={{ width: "100%" }}>
                  <SubAdminAddUpatecant>
                    <div className="subadmin_heading">Sub Admin Details</div>
                    <div className="row col-md-12">

                      <div className="col-md-5">
                        <label className="text-label_subadmin_heading">Sub Admin Name</label>
                        <Field name="firstName">
                          {({ field, meta }) => (
                            <div className="py-2">
                              <div>
                                <Input
                                  {...field}
                                  type="text"
                                  onChange={(e) => {
                                    setFieldValue("firstName", e.target.value);
                                  }}
                                  onBlur={handleBlur} // Ensure field is marked as touched
                                  className="form-control"
                                  placeholder="Enter Name"
                                  style={{
                                    background: values.firstName
                                      ? "#FFFFFF80"
                                      : "#FFFFFF",
                                  }}
                                />
                              </div>
                              {touched.firstName && errors.firstName && (
                                <p className="error mb-0">{errors.firstName}</p>
                              )}
                            </div>
                          )}
                        </Field>
                      </div>


                      <div className="col-md-5">
                        <label className="text-label_subadmin_heading">Sub Admin Title</label>
                        <Field name="subAdminTitle">
                          {({ field }) => (
                            <div className="py-2">
                              <div className="">
                                <Input
                                  {...field}
                                  type="test"
                                  onChange={(e) => {
                                    setFieldValue(
                                      "subAdminTitle",
                                      e.target.value
                                    );
                                  }}
                                  className="form-control"
                                  placeholder="Enter Title"
                                  style={{
                                    background: values.subAdminTitle
                                      ? "#FFFFFF80"
                                      : "#FFFFFF",
                                  }}
                                />
                              </div>
                              <p className="error mb-0">
                                {touched.subAdminTitle && errors.subAdminTitle
                                  ? errors.subAdminTitle
                                  : null}
                              </p>
                            </div>
                          )}
                        </Field>
                      </div>
                    </div>

                    <div className="subadmin_heading">Contact Information</div>
                    <div className="row col-md-12">
                      <div className="col-md-5">
                        <label className="text-label_subadmin_heading">Email Id</label>
                        <Field name="email">
                          {({ field }) => (
                            <div className="py-2">
                              <div className="">
                                <Input
                                  {...field}
                                  type="email"
                                  onChange={(e) => {
                                    setFieldValue("email", e.target.value);
                                  }}
                                  className="form-control"
                                  placeholder="Enter Email ID"
                                  style={{
                                    background: values.email
                                      ? "#FFFFFF80"
                                      : "#FFFFFF",
                                  }}
                                  disabled={adminStateData?._id}
                                />
                              </div>
                              <p className="error mb-0">
                                {touched.email && errors.email
                                  ? errors.email
                                  : null}
                              </p>
                            </div>
                          )}
                        </Field>
                      </div>

                      <div className="col-md-5">
                        <label className="text-label_subadmin_heading">Phone Number</label>
                        <Field name="phoneNumber">
                          {({ field }) => (
                            <div className="py-2">
                              <PhoneInput
                                className="form-control"
                                type="number"
                                country={"us"}
                                value={values.phoneNumber}
                                onChange={(phone, country) => {
                                  setFieldValue("phoneNumber", phone);
                                  setFieldValue("countryCode", country?.dialCode || ""); // Ensure countryCode is updated
                                }}

                                inputStyle={{
                                  background: values.phoneNumber
                                    ? "#FFFFFF80"
                                    : "#FFFFFF",
                                }}
                                isValid={(value, country) => {
                                  const phoneNumberLength = value.replace(
                                    /\D/g,
                                    ""
                                  ).length;
                                  return (
                                    phoneNumberLength >= 6 &&
                                    phoneNumberLength <= 18
                                  );
                                }}
                                placeholder="Select "
                              />
                              <p className="error mb-0">
                                <ErrorMessage name="phoneNumber" />
                              </p>
                            </div>
                          )}
                        </Field>
                      </div>
                    </div>

                    <div className="subadmin-notes-data">
                      <strong>Note: </strong>Sub Admin will receive an email with the new login credentials for panel access.
                    </div>
                  </SubAdminAddUpatecant>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                      padding: "1rem 0",
                    }}
                  >
                    <div className="common-heading">Manage Permission</div>

                    <TableContainer className={classes.tableMainContainer}>
                      <Table className={classes.table}>
                        <TableHead>
                          <TableRow className={classes.tableHeadingRow}>
                            <TableCell
                              className={classes.tableHeadingCell}
                              style={{ textAlign: "left", }}
                            >
                              <div style={{ marginLeft: "2rem" }}> Categories</div>

                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              View
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Add
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Edit
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Delete
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Block / Unblock
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Download
                            </TableCell>
                          </TableRow>
                        </TableHead>


                        <TableBody>
                          {values.modules.map((module, index) => (
                            <TableRow key={index} className={classes.tableBodyRow}>
                              <TableCell className={classes.textMiddle} style={{ textAlign: "left" }}>
                                <div className="text-Name_subAdmin">{module.moduleName}</div>
                              </TableCell>

                              {permissionOrder.map((permissionKey) => (
                                <TableCell key={permissionKey} className={classes.textMiddle}>
                                  <Checkbox
                                    size="small"
                                    color="primary"
                                    checked={module.permissions[permissionKey]}
                                    disabled={
                                      disabledPermissions[module.moduleName]?.includes(permissionKey)
                                    }
                                    onChange={(e) => {
                                      const updatedModules = [...values.modules];
                                      const isChecked = e.target.checked;

                                      updatedModules[index].permissions[permissionKey] = isChecked;

                                      if (
                                        ["add", "edit", "delete", "blockUnblock", "download"].includes(
                                          permissionKey
                                        ) &&
                                        isChecked
                                      ) {
                                        updatedModules[index].permissions["view"] = true;
                                      }

                                      if (permissionKey === "view" && !isChecked) {
                                        updatedModules[index].permissions["add"] = false;
                                        updatedModules[index].permissions["edit"] = false;
                                        updatedModules[index].permissions["delete"] = false;
                                        updatedModules[index].permissions["blockUnblock"] = false;
                                        updatedModules[index].permissions["download"] = false;
                                      }

                                      setFieldValue("modules", updatedModules);
                                    }}
                                  />
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    
                    </TableContainer>

                      {touched.modules && errors.modules && (
                        <p className="error mb-0">{errors.modules}</p>
                      )}
                      
                    <Button
                      type="submit"
                      disabled={isLoading}
                      style={{
                        backgroundColor: "#5088FB",
                        color: "#ffffff",
                      }}
                    >
                      {values._id ? "Update" : "Save"}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateSubAdmin);
